import React from "react";
import "./App.css";
import MainRoutes from "./components/Route.js"

function App() {
  return (
    <div className="App">
      <MainRoutes/>

    </div>
  );
}

export default App;
